import React from "react";

// package
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// componet
import Pill from "../../../common/Pill";
// styles
import styles from "./DepositAmount.module.scss";

const DepositAmount = () => {
  const { t } = useTranslation();

  return (
    <Pill
      styleName={"depositAmount"}
      Lefticon={<img src={"../../../assets/images/svg/moneyPurple.svg"} />}>
      <p className={classNames(styles.text, "p2")}>{t("lbl_deposit_amount")}</p>
    </Pill>
  );
};

export default DepositAmount;
